import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoute = (props: any) => {
    const RouteComponent = props.component
    const RouteProps = RouteComponent.props
    return <Route
        {...props.rest}
        exact={props.exact}
        component={(childProps: any) =>
            props.isUserAuthenticated ? (

                <RouteComponent {...RouteProps} />

            ) : (
                    <Redirect to={props.redirectTo} />
                )
        }
    />
}

const mapStateToProps = (state: any) => ({
    isUserAuthenticated: state.authReducer.isUserAuthenticated,
});

export default connect(mapStateToProps)(PrivateRoute);
